module.exports = __webpack_public_path__ + "static/_naitsaLogo-1fd75203d1ff95c53f9c505151fc5956.png";